<template>
  <div class="container is-fullhd">
    <div>
      <br/>
      <img @click="$root.$emit('changePage', 'card')" src="../assets/header.png">
    </div>
    <div class="section" v-if="error">
      <div class="notification is-danger">
        {{ error }}
      </div>
    </div>
    <div class="section">
      <div class="notification">
        <div v-if="!isSubmitPurchase">
          <div class="columns">
            <div class="column is-three-quarters">
              <p>Duid eerst één of meerdere geschenkjes aan die je wenst aan
                te kopen door het winkelwagentje naast het geschenkje aan te klikken.
              </p>
              <p class="subtitle is-7">
                PS: klik op de afbeelding van een geschenkje om ze te vergroten/verkleinen
              </p>
              <div v-if="priceTotal !== 0">
                <br/>
                <p class="has-text-weight-bold">
                  Je hebt {{ itemsAdded.length }}
                  geschenkje{{ itemsAdded.length > 1 ? 's' : '' }}
                  geselecteerd voor een totaal van {{ priceTotal | toCurrency }}.
                </p>
                <p>Druk op de rode knop om verder te gaan met je aankoop.</p>
              </div>
            </div>
            <div class="column has-text-right">
              <div class="button is-info" :disabled="itemsAdded.length === 0"
                   @click="itemsAdded.length !== 0 ? isSubmitPurchase = true : null">
                Ga verder met je aankoop
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="isSubmitPurchase && !isSubmitPayment">
          <p>
            Alice wil graag weten wie bedankt mag worden!
          </p>
          <br/>
          <input class="input" type="text" placeholder="Naam"
                 v-model="name">
          <br/>
          <br/>
          <p class="has-text-centered">
            Het bedrag ({{ priceTotal | toCurrency }}) mag overgeschreven
            worden op <span class="has-text-weight-bold">BE57 0636 1841 3835</span>.</p>
          <br/>
          <div class="button is-info is-fullwidth"
               :disabled="!name"
               @click="purchaseItems">
            <span v-if="itemsAdded.length > 1">
              De geschenkjes zijn betaald, bevestig je aankoop
            </span>
            <span v-else>
              Bevestig je aankoop
            </span>
          </div>
          <br/>
          <div class="button is-outlined is-fullwidth"
               @click="isSubmitPurchase = false">
            Wijzig je aankoop
          </div>
        </div>
        <div v-else-if="isSubmitPayment">
          <p>Dankjewel {{ name }} om deze mooie spulletjes aan te kopen! ;)</p>
          <br/>
          <p>Tot binnenkort!</p>
          <br/>
          <p>Liefs,</p>
          <p>Evelyn, Erik, Ada & Alice</p>
          <br/>
          <br/>
          <br/>
          <div class="button is-outlined is-fullwidth"
               @click="$root.$emit('changePage', 'card')">
            Ga terug naar de hoofdpagina
          </div>
          <br/>
          <div class="button is-outlined is-fullwidth"
               @click="isSubmitPurchase = false, isSubmitPayment = false">
            Ga terug naar de lijst
          </div>
        </div>
      </div>
      <div v-if="!isSubmitPayment">
        <h1 v-if="isSubmitPurchase" class="title is-3">
          Jouw geschenkje{{ itemsAdded.length > 1 ? 's' : ''}} voor Alice
        </h1>
        <div v-for="item in itemsShown" :key="item.id">
          <div class="box">
            <article class="media">
              <figure class="media-left">
                <p class="image is-128x128" >
                  <img data-zoomable
                       :src="item.photo ? `https://images.alice.gent/${item.photo}` : 'photos/no_photo.png'"
                       style="max-height: 100%;width: auto; margin: auto;">
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <p class="has-text-weight-bold is-info">
                    {{ item.title }}
                    <span class="tag" v-if="item.tweedehands">
                    tweedehands
                  </span>
                  </p>
                  {{ item.description }}
                </div>
              </div>
              <div class="media-right">
                <p class="has-text-weight-bold">{{ item.price | toCurrency }}</p>
                <font-awesome-icon
                    v-if="!isSubmitPurchase"
                    @click="toggleItem(item)"
                    :class="hasItem(item) ? 'has-text-primary' : 'has-text-grey-light'"
                    :icon="hasItem(item) ? 'shopping-cart' : 'cart-arrow-down'"
                    size="2x"/>
              </div>
            </article>
          </div>
        </div>
        <br/>
        <div v-if="!isSubmitPurchase">
          <div class="menu-label notification" v-if="itemsAdded.length > 0">
            Ga naar boven om je aankoop te bevestigen.
          </div>
          <h1 class="title is-3">Reeds aangekocht door anderen</h1>
          <div v-for="item in itemsSold" :key="item.id">
            <div class="box has-text-grey-light">
              <article class="media">
                <figure class="media-left">
                  <p class="image is-128x128">
                    <img data-zoomable :src="item.photo ?
                      `https://images.alice.gent/${item.photo}` : 'photos/no_photo.png'"
                      style="max-height: 100%;width: auto; margin: auto;">
                  </p>
                </figure>
                <div class="media-content">
                  <div class="content">
                    <p class="has-text-weight-bold">
                      {{ item.title }}
                      <span class="tag" v-if="item.tweedehands">
                      tweedehands
                    </span>
                    </p>
                    {{ item.description }}
                  </div>
                </div>
                <div class="media-right">
                  <p class="has-text-weight-bold">&euro; {{ item.price }}</p>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mediumZoom from 'medium-zoom';

export default {
  name: 'List',
  props: {
    items: Array,
  },
  data() {
    return {
      itemsAdded: [],
      error: null,
      isPasswordValid: false,
      isSubmitPurchase: false,
      isSubmitPayment: false,
      name: null,
      zoom: null,
    };
  },

  created() {
    this.enableMediumZoom();
    window.onbeforeunload = () => 'Jouw aankoop zal verloren gaan als je de pagina verlaat.';
  },

  watch: {
    isSubmitPurchase() {
      this.enableMediumZoom();
    },
    isSubmitPayment() {
      this.enableMediumZoom();
    },
  },

  computed: {
    priceTotal() {
      const prices = this.itemsAdded.map((item) => item.price);
      return prices.reduce((priceTotal, price) => priceTotal + price, 0);
    },
    itemsAvailable() {
      return this.items.filter((item) => !item.is_purchased);
    },
    itemsSold() {
      return this.items.filter((item) => item.is_purchased);
    },
    itemsShown() {
      if (!this.isSubmitPurchase && !this.isSubmitPayment) {
        return this.itemsAvailable;
      } if (this.isSubmitPurchase && !this.isSubmitPayment) {
        return this.itemsAdded;
      }
      return this.itemsAvailable;
    },
  },

  methods: {
    enableMediumZoom() {
      this.$nextTick(() => {
        const images = [
          ...document.querySelectorAll('[data-zoomable]'),
        ];
        if (this.zoom) {
          this.zoom.detach();
          this.zoom.attach(images);
        } else {
          this.zoom = mediumZoom(images);
        }
      });
    },

    toggleItem(item) {
      if (this.hasItem(item)) {
        this.itemsAdded.splice(this.itemsAdded.indexOf(item), 1);
      } else {
        this.itemsAdded.push(item);
      }
    },

    hasItem(item) {
      return this.itemsAdded.includes(item);
    },

    async purchaseItems() {
      if (!this.name) return;

      try {
        this.itemsAdded.forEach(async function (val, index, items) {
          const item = items[index];
          item.is_purchased = true;
          item.buyers = this.name;
          item.last_update = new Date().toJSON();
          await this.$root.$emit('purchaseItem', item);
        }, this);
        this.itemsAdded = [];
        this.isSubmitPayment = true;
      } catch (error) {
        this.error = 'Er is iets foutgelopen met je bestelling, '
            + 'probeer nog eens opnieuw of contacteer ons indien het probleem aanhoudt.';
      }
    },
  },
};
</script>
